import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import type { AffectedWorkPackage } from '@/common/soft-delete';

const STATUS_LABEL = {
	Pending: 'finance.status.pending',
	Assigned: 'finance.status.assigned',
	Completed: 'finance.status.completed',
} as const;

/**
 * Work packages a delete or restore affects, one per line: "Bridge deck (Pending, 3 lines)". The title
 * links to the package, e.g. to reopen a completed one that blocks a delete.
 */
export function WorkPackageList({
	workPackages,
	showLines = true,
}: {
	workPackages: AffectedWorkPackage[];
	showLines?: boolean;
}) {
	const { t } = useTranslation();
	return (
		<ul className="max-h-40 list-disc space-y-0.5 overflow-y-auto pl-5 text-sm">
			{workPackages.map((workPackage) => {
				const title = workPackage.title || t('common.deleted.workPackageUntitled');
				const status = t(STATUS_LABEL[workPackage.status]);
				return (
					<li key={workPackage.id}>
						<Link
							to={`/assets/${workPackage.assetId}/finance/work-packages/${workPackage.id}`}
							className="font-medium underline underline-offset-2 hover:text-primary"
						>
							{title}
						</Link>{' '}
						{showLines
							? t('common.deleted.workPackageDetail', { status, count: workPackage.itemCount })
							: t('common.deleted.workPackageStatus', { status })}
					</li>
				);
			})}
		</ul>
	);
}
